'use client';

// import { Distributor } from '../..';
// import type { DistributorProps } from '../..';
import { Distributor } from '@larvitu/shared/react/components/feature-distributor';

import { usePopperContext } from './hooks';

import type { PopperContext } from './context';
import type { DistributorProps } from '@larvitu/shared/react/components/feature-distributor';
import type { HeaderContextProps } from '@larvitu/shared/react/context/feature-header-context';
import type { FC } from 'react';

// todo: reduce the type of the type children: DistributorProps to the keys of T
// { [Key in T[number]]: PopperContext[Key] } is not reducing the props correctly
export interface PopperConsumeProps<
  T extends Array<keyof PopperContext> = Array<keyof PopperContext>,
> {
  children: DistributorProps<
    {
      [Key in T[number]]: PopperContext[Key];
    }
  >['children'];
  props?: T;
}

/* type testing */

// type B = { foo: 'foo'; bar: 'bar'; baz: 'baz' };
// type A = ['foo', 'baz']

/* reduce by keys[] */

// type X<T extends A = A> = { [Key in T[number]]: B[Key] }
// type z = X // => {foo: 'foo', baz: 'baz'}

export const PopperConsumer: FC<PopperConsumeProps> = ({ children, props }) => {
  let popperContext = usePopperContext();

  if (props) {
    popperContext = props.reduce<Partial<HeaderContextProps>>(
      (acc, key) => ({
        ...acc,
        [key]: popperContext[key],
      }),
      {}
    );
  }

  return (
    <Distributor {...{ ...popperContext, ...props }}>
      {children}
    </Distributor>
  );
};
